<template>
  <info-header-card :icon="'address-book'" :header="'Contact Info'" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import * as URI from "uri-js";

export default {
  name: "LaboratoryContactCard",
  components: {
    InfoHeaderCard
  },
  props: {
    laboratory: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    rows() {
      return [
        {
          label: "Phone",
          value: this.laboratory.phone
        },
        {
          label: "Fax",
          value: this.laboratory.fax
        },
        {
          label: "Email",
          value: this.laboratory.email
        },
        {
          label: "Website",
          value: this.formatWebsite()
        },
        {
          label: "Address",
          value: this.formatAddress()
        }
      ];
    }
  },
  methods: {
    formatWebsite() {
      let formatted = null;
      if (this.laboratory.website && this.laboratory.website.length) {
        let parsed = URI.parse(this.laboratory.website);
        if (typeof parsed.scheme === "undefined") {
          formatted = `https://${this.laboratory.website}`;
        } else {
          formatted = this.laboratory.website;
        }
      }
      return formatted;
    },
    formatAddress() {
      return "Address";
      // #TODO
    }
  }
};
</script>
